import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { DetailRow } from 'src/components';
import { SummarySectionTitle } from 'src/components/OligoDNA/components/Summary/components';
import {
  PLATE_POOLING,
  PLATE_POOLING_OPTIONS,
  CLOSED_ANSWERS,
} from 'src/constants/forms';
import RemaindersDetails from '../RemaindersDetails';

import messages from '../../messages';

const messagesByValues = {
  [CLOSED_ANSWERS.yes]: messages.yes,
  [CLOSED_ANSWERS.no]: messages.no,
  [PLATE_POOLING_OPTIONS.NONE]: messages.none,
  [PLATE_POOLING_OPTIONS.HALVES]: messages.halves,
  [PLATE_POOLING_OPTIONS.ODD_EVEN]: messages.oddEven,
  [PLATE_POOLING_OPTIONS.CUSTOM]: messages.custom,
};

const PlatePoolingDetailsComponent = ({
  details,
  showTitle,
  onEditClick,
}) => (
  <>
    <Visible when={showTitle}>
      <SummarySectionTitle
        titleMessage={messages.platePoolingSubTitle}
        onEditClick={onEditClick}
      />
      <Spacer bottom={8} />
    </Visible>
    <DetailRow
      label={messages.platePoolingSubTitle}
      value={
        <Message message={messagesByValues[details[PLATE_POOLING]?.value]} />
      }
      dots
    />
    <Spacer bottom={8} />
    <RemaindersDetails visible={
      details[PLATE_POOLING]?.value &&
      details[PLATE_POOLING]?.value !== PLATE_POOLING_OPTIONS.NONE
    }
    />
  </>
);

PlatePoolingDetailsComponent.propTypes = {
  details: PropTypes.object.isRequired,
  showTitle: PropTypes.bool,
  onEditClick: PropTypes.func,
};

export default PlatePoolingDetailsComponent;
